import React from 'react';
import {
  FiAlertTriangle,
  FiChevronRight,
  FiDownloadCloud,
  FiFeather,
  FiFolderPlus,
  FiGrid,
  FiHome,
  FiImage,
  FiLock,
  FiMaximize,
  FiMenu,
  FiShield,
  FiUploadCloud,
  FiX,
} from 'react-icons/fi';

const icons = {
  AlertTriangle: FiAlertTriangle,
  ChevronRight: FiChevronRight,
  DownloadCloud: FiDownloadCloud,
  Feather: FiFeather,
  FolderPlus: FiFolderPlus,
  Grid: FiGrid,
  Home: FiHome,
  Image: FiImage,
  Lock: FiLock,
  Maximize: FiMaximize,
  Menu: FiMenu,
  Shield: FiShield,
  UploadCloud: FiUploadCloud,
  X: FiX,
};

const SafeIcon = ({ icon, name, ...props }) => {
  const IconComponent = icon || icons[name] || FiAlertTriangle;
  return React.createElement(IconComponent, props);
};

export default SafeIcon;